'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (numberString) {
  if (!numberString) {
    return '';
  }

  return numberString.replace(/[^\d]/g, '');
};